/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TradeWithSymbolDto,
    TradeWithSymbolDtoFromJSON,
    TradeWithSymbolDtoFromJSONTyped,
    TradeWithSymbolDtoToJSON,
} from './TradeWithSymbolDto';

/**
 * 
 * @export
 * @interface UpdatedTradeDto
 */
export interface UpdatedTradeDto {
    /**
     * 
     * @type {TradeWithSymbolDto}
     * @memberof UpdatedTradeDto
     */
    trade?: TradeWithSymbolDto;
    /**
     * 
     * @type {string}
     * @memberof UpdatedTradeDto
     */
    symbol?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatedTradeDto
     */
    currenciesForSymbol?: Array<string>;
}

export function UpdatedTradeDtoFromJSON(json: any): UpdatedTradeDto {
    return UpdatedTradeDtoFromJSONTyped(json, false);
}

export function UpdatedTradeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatedTradeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'trade': !exists(json, 'trade') ? undefined : TradeWithSymbolDtoFromJSON(json['trade']),
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'currenciesForSymbol': !exists(json, 'currenciesForSymbol') ? undefined : json['currenciesForSymbol'],
    };
}

export function UpdatedTradeDtoToJSON(value?: UpdatedTradeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade': TradeWithSymbolDtoToJSON(value.trade),
        'symbol': value.symbol,
        'currenciesForSymbol': value.currenciesForSymbol,
    };
}

